import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './tutorial-card-info-mobile.scss';
import TutorialMobile from '@assets/images/tutorial-mobile.svg';
import CheckIcon from '@assets/icons/check-icon-min.svg';
import Box from '@mui/material/Box';
import Button from '../button/button';
import { detectarSO, openAppGallery, openAppStore, openPlayStore } from '../../../utils/utils';
import { useEffect, useState } from 'react';
import dataLayerService from '../../../services/data-layer-service';
const TutorialCardInfoMobile = () => {
    const pathname = location.pathname;
    const [isTutorial, setIsTutorial] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    useEffect(() => {
        setIsTutorial(pathname.toLowerCase().includes('tutorial'));
    }, []);
    const handleOpenStore = () => {
        switch (detectarSO()) {
            case 'android':
                handleDataLayer(isTutorial ? 'Final_Descarga_Android' : 'Paso0_Cliente_Android', 'Google Play', 'Boton');
                openPlayStore();
                break;
            case 'ios':
                handleDataLayer(isTutorial ? 'Final_Descarga_iOS' : 'Paso0_Cliente_iOS', 'App Store', 'Boton');
                openAppStore();
                break;
            case 'harmony':
                handleDataLayer(isTutorial ? 'Final_Descarga_Huawei' : 'Paso0_Cliente_Huawei', 'App Gallery', 'Boton');
                openAppGallery();
                break;
        }
    };
    const handleDataLayer = (eventName, valor, elemento) => {
        dataLayerService.sendEvent(eventName, {
            Seccion: '',
            SubSeccion: '',
            SubZona: 'Cliente',
            TipoElemento: elemento,
            TipoEvento: 'Click',
            TipoZona: 'Onboarding Digital',
            Valor: valor,
            Zona: 'Paso 0'
        });
    };
    const handleImageLoad = () => {
        setImageLoaded(true);
    };
    return (_jsxs(Box, { className: "tutorial-card-info-mobile", children: [_jsxs(Box, { className: "tutorial-card-info-mobile_title", children: ["Descarga la app ", _jsx("br", {}), " ", _jsx("span", { children: "Mibanco" })] }), _jsx(Button, { action: handleOpenStore, label: 'Descarga la App', isAnimated: true }), _jsxs(Box, { className: "tutorial-card-info-mobile_features", children: [_jsxs(Box, { className: "tutorial-card-info-mobile_features_item", children: [_jsx("img", { src: CheckIcon, alt: "check-icon-min" }), _jsx("span", { children: "Operaciones al instante" })] }), _jsxs(Box, { className: "tutorial-card-info-mobile_features_item", children: [_jsx("img", { src: CheckIcon, alt: "check-icon-min" }), _jsx("span", { children: "Transferencias ilimitadas" })] }), _jsxs(Box, { className: "tutorial-card-info-mobile_features_item", children: [_jsx("img", { src: CheckIcon, alt: "check-icon-min" }), _jsx("span", { children: "Pr\u00E9stamos al toque" })] }), _jsxs(Box, { className: "tutorial-card-info-mobile_features_item", children: [_jsx("img", { src: CheckIcon, alt: "check-icon-min" }), _jsx("span", { children: "Atenci\u00F3n 24/7" })] })] }), _jsx("div", { children: _jsx("img", { src: TutorialMobile, alt: "tutorial-mobile", onLoad: handleImageLoad, style: { display: imageLoaded ? 'block' : 'none' } }) })] }));
};
export default TutorialCardInfoMobile;
